<template>
  <b-sidebar
    id="sidebar-assign-direction-sector-code"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
    @shown="loadCurrentMappings"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Assign science sector') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>

      <b-form
        class="p-2"
        @submit.prevent="submit(hide)"
      >
        <b-form-group :label="$t('Direction')">
          <b-form-input
            :value="directionLabel"
            readonly
          />
        </b-form-group>

        <b-form-group
          :label="$t('Category Subject')"
          label-for="direction-science-sector"
        >
          <v-select
            id="direction-science-sector"
            v-model="selectedCategorySubjects"
            :options="categorySubjectOptions"
            label="text"
            :reduce="option => option.value"
            :placeholder="$t('Select')"
            :disabled="isBusy"
            :close-on-select="false"
            multiple
          />
        </b-form-group>

        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            :disabled="!direction.id || isBusy"
          >
            {{ $t('Save') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    direction: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedCategorySubjects: [],
      currentMappings: [],
      isBusy: false,
    }
  },
  computed: {
    directionLabel() {
      if (!this.direction.id) return ''
      return `${this.direction.code} - ${this.$langName(this.direction.name)}`
    },
    categorySubjectOptions() {
      return this.$store.state.directionSectorCode.categorySubjects.map(categorySubject => ({
        value: categorySubject.id,
        text: `${categorySubject.science_sector_code || categorySubject.code} - ${this.$langName(categorySubject.name)}`,
      }))
    },
  },
  methods: {
    clear(hide) {
      this.selectedCategorySubjects = []
      this.currentMappings = []
      this.$store.commit('directionSectorCode/FRESH')
      hide()
    },
    loadCurrentMappings() {
      if (!this.direction.id) return
      this.isBusy = true
      this.$store.dispatch('directionSectorCode/list', {
        direction_id: this.direction.id,
        limit: 9999,
      }).then(response => {
        this.currentMappings = response.data.results || response.data
        this.selectedCategorySubjects = this.currentMappings.map(item => item.category_subject)
      }).catch(error => {
        this.$errorSwal(this, error)
      }).finally(() => {
        this.isBusy = false
      })
    },
    submit(hide) {
      const currentCategorySubjectIds = this.currentMappings.map(item => item.category_subject)
      const mappingsToCreate = this.selectedCategorySubjects
        .filter(id => !currentCategorySubjectIds.includes(id))
      const mappingsToDelete = this.currentMappings
        .filter(item => !this.selectedCategorySubjects.includes(item.category_subject))

      const operations = [
        ...mappingsToCreate.map(categorySubject => this.$store.dispatch('directionSectorCode/create', {
          direction: this.direction.id,
          category_subject: categorySubject,
        })),
        ...mappingsToDelete.map(item => this.$store.dispatch('directionSectorCode/del', { id: item.id })),
      ]

      this.isBusy = true
      Promise.all(operations).then(() => {
        this.$bvToast.toast(this.$t('Successfully completed'), {
          variant: 'success',
          solid: true,
          title: this.$t('Success'),
        })
        this.selectedCategorySubjects = []
        this.currentMappings = []
        this.$store.commit('directionSectorCode/FRESH')
        hide()
      }).catch(error => {
        this.$errorSwal(this, error)
      }).finally(() => {
        this.isBusy = false
      })
    },
  },
}
</script>
